import React, { useEffect } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button
} from '@mui/material';
import { useSelector } from 'react-redux';
import { selectLatestTicks,makeSelectLatestTicksByTokens } from '../../redux/selectors/ltpSelectors';

import { useMemo } from 'react';

const calculateLiveProfit = (entryPrice, ltp, quantity) => {
  if (ltp <= 0 || entryPrice <= 0 || !Number.isFinite(quantity)) return "N/A";
  return ((ltp - entryPrice) * quantity).toFixed(2);
};

const OrderTable = ({ orders = [], squareOffStatus, onSquareOff }) => {
  
  // Get all unique tokens from orders
  const orderTokens = [...new Set(orders.map(order => String(order.token)))];
  const ltpData = useSelector(makeSelectLatestTicksByTokens(orderTokens));

 
  const getLTPForToken = (token) => {
    const latestTick = ltpData[token];
    console.log("latestTick in posorder token and ltp ",token ,latestTick)
    return latestTick?.price || 0;
  };
  

  return (
    <Table
      size="small"
      sx={{
        border: '1px solid #ccc',
        borderCollapse: 'separate',
        '& .MuiTableCell-root': {
          border: 'none',
          padding: '4px 8px',
          fontSize: '0.75rem',
        },
        '& .MuiTableHead-root .MuiTableCell-root': {
          backgroundColor: '#f5f5f5',
          fontWeight: 'bold',
        },
      }}
    >
      <TableHead>
        <TableRow>
          <TableCell>Option</TableCell>
          <TableCell>Entry</TableCell>
          <TableCell>LTP</TableCell>
          <TableCell>Profit</TableCell>
          <TableCell>(%)</TableCell>
          <TableCell>
            <Button
              size="small"
              variant="outlined"
              disabled={squareOffStatus}
              sx={{
                color: "red",
                borderColor: "red",
                fontSize: "0.7rem",
                padding: "2px 6px",
                minWidth: 0,
                '&:hover': {
                  backgroundColor: "#ffe5e5",
                  borderColor: "darkred",
                },
              }}
              onClick={() => onSquareOff(orders)}
            >
              SQ.All
            </Button>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {orders.map((order) => {
          let token = String(order.token);
          let ltp = getLTPForToken(token) || order.exit_price || order.exit_decision_ltp || 0;
          let profit = calculateLiveProfit(order.entry_price, ltp, order.quantity);
          let returnPct = ((profit / (order.entry_price * order.quantity)) * 100).toFixed(2);

          const rowStyle =
            profit < 0 ? { backgroundColor: '#ffe6e6' }
            : profit > 0 ? { backgroundColor: '#e6ffe6' }
            : {};

          return (
            <TableRow key={order.documentId} sx={rowStyle}>
              <TableCell>{order.option_type == "PE"?"PUT":"CALL"}</TableCell>
              <TableCell>{order.entry_price}</TableCell>
              <TableCell>{ltp}</TableCell>
              <TableCell>{profit}</TableCell>
              <TableCell>{returnPct}</TableCell>
              <TableCell>
                {order.order_status?.toLowerCase() === "open" && (
                  <Button
                    size="small"
                    variant="contained"
                    disabled={squareOffStatus}
                    sx={{
                      backgroundColor: "red !important",
                      color: "white !important",
                      fontSize: "0.7rem",
                      padding: "2px 6px",
                      minWidth: 0,
                      '&:hover': {
                        backgroundColor: "darkred !important",
                      },
                    }}
                    onClick={() => onSquareOff([order])}
                  >
                    SQ.Off
                  </Button>
                )}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default OrderTable;
